import ViewSprawozdanieGantt
    from "../../components/views/sprawozdania/lib/components/sprawozdanieGantt/pages/ViewSprawozdanieGantt.jsx";
import ViewSprawozdanieForm from "../../components/views/sprawozdania/wp/sprawozdanieForm/ViewSprawozdanieForm.jsx";
import ViewListaSprawozdan from "../../components/views/sprawozdania/wp/listaSprawozdan/ViewListaSprawozdan.jsx";

export const sprawozdaniaRoutes = [

    {
        path: `/wp/sprawozdanie/lista/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewListaSprawozdan/>,
        mode: `pass`,
    },

    {
        path: `/wp/sprawozdanie/:tryb/:rejestrId/:sprawozdanieId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewSprawozdanieForm/>,
        mode: `pass`,
    },

    {
        path: `/wp/sprawozdanie/:tryb/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewSprawozdanieForm/>,
        mode: `pass`,
    },

    {
        path: `/wp/sprawozdanie/gantt/:rejestrId`,
        exact: true,
        roles: [],
        forbidden: true,
        view: <ViewSprawozdanieGantt/>,
        mode: `pass`,
    },
]
